import ApiController from '@/services/ApiController'
import { WALKER_COMMANDS } from '@/services/helpers/ElbwalkerHelper'
import destinationGoogleGA4 from '@elbwalker/destination-web-google-ga4'
import { elb, Walkerjs } from '@elbwalker/walker.js'

const ELBWALKER_TOGGLE = 'log_elbwalker'

const ga4Config = {
  consent: {
    marketing: true
  },
  custom: {
    measurementId: 'G-WF8BMGZN9S',
    include: ['all'],
    snakeCase: true
  }
  // loadScript: true
}

// Tracking is browser-only: walker.js session state, destinations and the
// debug toggle all live on window/localStorage (VIP-12036)
if (!import.meta.env.SSR) {
  const urlParams = new URLSearchParams(window.location.search)
  const partnerId = urlParams.get('partner_id')

  window.walkerjs = Walkerjs({
    session: {
      storage: true,
      length: 30,
      data: {
        partner_id: partnerId
      }
    }
  })
  window.elb = elb

  // Add destinations
  elb(WALKER_COMMANDS.destination, {
    push: ApiController.sendEventToDataMining
  })

  if (
    import.meta.env.VITE_APP_TRACKING_ENABLED === 'ON' &&
    location.hostname === 'www.vicampo.de'
  ) {
    elb(WALKER_COMMANDS.destination, destinationGoogleGA4, ga4Config)
  }

  // Only enable console logging when explicitly 'true' (Tool/dialog toggle).
  // Avoid treating "false" as truthy when the dialog stores the boolean off state.
  if (localStorage.getItem(ELBWALKER_TOGGLE) === 'true') {
    elb(WALKER_COMMANDS.destination, { push: console.log })
  }
}
